import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { StartTimeFilterScreenProps } from 'home/stack/types'
import { cloneDeep, isEqual } from 'lodash'
import React, { useCallback, useLayoutEffect, useState } from 'react'
import { useFiltersContext } from 'schedule/filters/context'
import { SingleSelectSettingView } from 'settings/screens/types/single_select/view'
import { SettingValue } from 'settings/types'
import { showHeaderButton } from 'shared/header/header_button'

export function StartTimeFilterScreen({
  navigation,
}: StartTimeFilterScreenProps) {
  const { theme } = useTheme()

  const {
    currentFilters,
    setCurrentFiltersWithToggle,
    setCurrentSelectedPresetIndex,
  } = useFiltersContext()
  const startTimeFilter = currentFilters['startTime']

  const [selectedId, setSelectedId] = useState<string>(
    startTimeFilter.selectedId
  )
  const [startTime, setStartTime] = useState<SettingValue[]>(
    startTimeFilter.values
  )

  const onSelectId = (value: SettingValue) => {
    setSelectedId(value.id)
  }

  const setPositionFilter = useCallback(() => {
    const newStartTimeFilter = {
      ...startTimeFilter,
      values: startTime,
      selectedId,
    }
    const newFilters = cloneDeep(currentFilters)
    if (
      !isEqual(
        newFilters['startTime'].selectedId,
        newStartTimeFilter.selectedId
      )
    ) {
      newFilters['startTime'] = newStartTimeFilter
      setCurrentFiltersWithToggle(newFilters)
      setCurrentSelectedPresetIndex(undefined)
    }
  }, [
    currentFilters,
    startTime,
    startTimeFilter,
    selectedId,
    setCurrentFiltersWithToggle,
    setCurrentSelectedPresetIndex,
  ])

  useLayoutEffect(
    () =>
      showHeaderButton({
        navigation,
        theme,
        title: t('done'),
        onPress: async () => {
          setPositionFilter()
          navigation.goBack()
        },
      }),
    [navigation, setPositionFilter, theme]
  )

  return (
    <SingleSelectSettingView
      selectedId={selectedId}
      values={startTime}
      onSelectValue={onSelectId}
    />
  )
}
